(function () {
  function initProtectionPlan() {
    var protectionBox = document.querySelector('[data-camplux-protection-plan]');
    if (!protectionBox || protectionBox.dataset.initialized === 'true') return;

    protectionBox.dataset.initialized = 'true';

    var optionButtons = protectionBox.querySelectorAll('.camplux-protection-option');
    var variantInput = protectionBox.querySelector('input[name="camplux_protection_variant_id"]');
    var nameInput = protectionBox.querySelector('input[name="camplux_protection_name"]');

    protectionBox.addEventListener('click', function (event) {
      var button = event.target.closest('.camplux-protection-option');
      if (!button || !protectionBox.contains(button)) return;
      if (button.classList.contains('is-active')) return;

      optionButtons.forEach(function (item) {
        item.classList.remove('is-active');
        item.setAttribute('aria-pressed', 'false');
      });

      button.classList.add('is-active');
      button.setAttribute('aria-pressed', 'true');

      if (variantInput) {
        variantInput.value = button.getAttribute('data-protection-variant-id') || '';
      }

      if (nameInput) {
        nameInput.value = button.getAttribute('data-protection-name') || '';
      }
    });
  }

  async function addItemsToCart(items) {
    var response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items: items })
    });

    if (!response.ok) {
      var errorText = await response.text();
      throw new Error(errorText || 'Add to cart failed');
    }

    return response.json();
  }

  function getQuantity(form) {
    var quantityInput = form.querySelector('[name="quantity"]');
    var quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;
    return quantity && quantity > 0 ? quantity : 1;
  }

  function initAddToCartIntercept() {
    if (window.__campluxProtectionSubmitReady) return;
    window.__campluxProtectionSubmitReady = true;

    document.addEventListener('submit', async function (event) {
      var form = event.target;

      if (!form || !form.matches('form[action*="/cart/add"]')) return;

      var protectionBox = document.querySelector('[data-camplux-protection-plan]');
      if (!protectionBox) return;

      var protectionVariantInput = protectionBox.querySelector('input[name="camplux_protection_variant_id"]');
      var protectionNameInput = protectionBox.querySelector('input[name="camplux_protection_name"]');

      var protectionVariantId = protectionVariantInput ? protectionVariantInput.value : '';
      var protectionName = protectionNameInput ? protectionNameInput.value : '';

      if (!protectionVariantId) return;

      event.preventDefault();
      event.stopPropagation();

      if (event.stopImmediatePropagation) {
        event.stopImmediatePropagation();
      }

      var formData = new FormData(form);
      var mainVariantId = formData.get('id');
      var quantity = getQuantity(form);
      var productTitle = protectionBox.getAttribute('data-product-title') || document.title;

      if (!mainVariantId) {
        alert('Please select a product option first.');
        return;
      }

      var submitButton = form.querySelector('[type="submit"], button[name="add"]');
      var oldButtonText = '';

      if (submitButton) {
        oldButtonText = submitButton.innerHTML;
        submitButton.disabled = true;
        submitButton.innerHTML = 'Adding...';
      }

      var items = [
        {
          id: Number(mainVariantId),
          quantity: quantity
        },
        {
          id: Number(protectionVariantId),
          quantity: quantity,
          properties: {
            'Protection Plan': protectionName,
            'Protection For': productTitle,
            '_Main Product Variant ID': String(mainVariantId)
          }
        }
      ];

      try {
        await addItemsToCart(items);
        window.location.href = '/cart';
      } catch (error) {
        console.error(error);
        alert('The protection plan could not be added. Please try again.');

        if (submitButton) {
          submitButton.disabled = false;
          submitButton.innerHTML = oldButtonText || 'Add to cart';
        }
      }
    }, true);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initProtectionPlan();
    initAddToCartIntercept();
  });

  document.addEventListener('shopify:section:load', function () {
    initProtectionPlan();
    initAddToCartIntercept();
  });
})();